import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Modal } from '../../../components/modal/Modal';
import { MaterialIcon } from '../../../components/material-icon/MaterialIcon';

type Props = { closeModal: () => void; isOpen: boolean };

export const VerifyLawyerModalValidated: FC<Props> = ({
  closeModal,
  isOpen,
}) => (
  <Modal isOpen={isOpen} onRequestClose={closeModal}>
    <div className="small-modal__header">
      <button type="button" onClick={closeModal}>
        <MaterialIcon name="close" className="small-modal__close" />
      </button>
    </div>
    <div className="restricted-modal__content">
      <img src="/img/icons/verify.png" alt="verify-icon" />
      <div className="restricted-modal__title">
        <FormattedMessage id="entity/expertises/VerifyLawyerModalValidated.tsx/1" />
      </div>
      <div className="restricted-modal__verify__content">
        <span className="restricted-modal__verify__line__text__title">
          <FormattedMessage id="entity/expertises/VerifyLawyerModalValidated.tsx/2" />
        </span>
      </div>
      <button
        className="button large hollow secondary restricted-modal__verify__secondary-button"
        type="button"
        onClick={closeModal}
      >
        <FormattedMessage id="entity/expertises/VerifyLawyerModalValidated.tsx/3" />
      </button>
    </div>
  </Modal>
);
